module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Bottle#1-536d5d5a8983429e8330de1986eece7dd7649729b2abb4ec044c72dc81c0638d.svg";